function initTFDSlider() {

  const track = document.querySelector(
    '.related-products .product-grid'
  );

  const prev = document.querySelector(
    '.tfd-related-prev'
  );

  const next = document.querySelector(
    '.tfd-related-next'
  );

  if (!track || !prev || !next) return;

  if (track.dataset.sliderReady) return;

  track.dataset.sliderReady = 'true';

  const scrollAmount = 312;

  next.addEventListener('click', () => {

    track.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });

  });

  prev.addEventListener('click', () => {

    track.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });

  });

}

setInterval(initTFDSlider, 500);